
// SVG Icon: radio-on
export default { id: "terriajs-radio-on" };
export const id = "terriajs-radio-on";
export const name = "radio-on";
